module.exports = __webpack_public_path__ + "public/media/img_familymove_guide.080a2a74.jpg";